import styled from '../../../theme'

const ModalControl = styled.div`
  display: flex;
  padding: 10px;
`

export default ModalControl
